"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.content = void 0;

var common_constants_1 = require("@ryerson/common.constants");

exports.content = {
  title: {
    en: "Joe is trying to find that page.",
    es: "Joe está tratando de encontrar esa página.",
    fr: "Joe essaie de trouver cette page."
  },
  body1: {
    en: "Need assistance? You can reach out to us through live chat, by sending an email to shop@ryerson.com or giving us a call at ".concat(common_constants_1.PhoneNumbers.RYERSON_US.number, "."),
    es: "\xBFNecesita ayuda? Puede comunicarse con nosotros enviando un correo electr\xF3nico a shop@ryerson.com o ll\xE1menos al ".concat(common_constants_1.PhoneNumbers.RYERSON_MX.number, "."),
    fr: "Je vois toujours ce message et besoin d'assistance? Vous pouvez nous joindre en envoyant un courriel \xE0 shop@ryerson.com ou appelez-nous au ".concat(common_constants_1.PhoneNumbers.RYERSON_CA.number, ".")
  },
  body2: {
    en: "While he continues his search, maybe you'd like to",
    es: "¿Mientras continúa su búsqueda, tal vez le gustaría",
    fr: "Pendant qu'il poursuit sa recherche, peut-être aimeriez-vous"
  },
  body2Link: {
    en: "start a search for some metal",
    es: "iniciar una búsqueda de algún metal",
    fr: "commencer une recherche de métal"
  },
  needHelp: {
    en: "Need Help?",
    es: "¿Necesitas ayuda?",
    fr: "Besoin d'aide?"
  },
  help1: {
    en: "You can always reach out to us! Our contact information can be",
    es: "¡Siempre puedes contactarnos! Nuestra información de contacto puede ser",
    fr: "Vous pouvez toujours nous contacter ! Nos coordonnées peuvent être"
  },
  help1Link: {
    en: "found here",
    es: "encontrado aquí",
    fr: "trouvé ici"
  },
  help2: {
    en: "Please include the following technical information when you contact us.",
    es: "Incluya la siguiente información técnica cuando se comunique con nosotros.",
    fr: "Veuillez inclure les informations techniques suivantes lorsque vous nous contactez."
  }
};